// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3pD7K","validationTips":"StatementDescriptor_validationTips__10fNf"};